<template>
    <div class="flex gap-2 items-center">
        <!-- Dropzone for new upload -->
        <div
            class="relative w-40 h-11 rounded-md border-2 border-dashed border-gray-200"
            v-if="! disabled"
        >
            <input
                type="file"
                id="fileUpload"
                class="absolute inset-0 z-50 m-0 p-0 w-full h-full outline-none opacity-0 cursor-pointer"
                v-on:dragover="adding = true"
                v-on:dragleave="adding = false"
                v-on:drop="adding = false"
                ref="file"
                @input="handleFileUpload"
            >

            <label for="fileUpload">
                <div
                    class="w-full h-full flex justify-center items-center"
                    :class="{ 'bg-gray-100' : adding }"
                >
                    <svg v-if="uploading" class="animate-spin mx-auto h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <div v-else>
                        {{ __('admin::labels.upload_file') }}
                    </div>
                </div>
            </label>
        </div>

        <!-- Link field -->
        <Input
            :modelValue="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
            :placeholder="__('admin::labels.link_to_file')"
        />

    </div>
</template>

<script>
import axios from "axios";
import Input from "@/Components/Input.vue";

export default {
    components: {Input},
    props: {
        modelValue: {
            type: [String, File],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            adding: false,
            uploading: false,
        };
    },
    emits: ['update:modelValue'],
    methods: {
        handleFileUpload(event) {
            this.uploading = true;
            let file = event.target.files[0];

            let request = new FormData();
            request.append('file', file);

            axios
                .post(this.$route('admin::files.store'), request, {
                    header: {
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then((res) => {
                    this.uploading = false;
                    this.$emit('update:modelValue', res.data.path);
                });
        },
    }
}
</script>
